import { MenuBreadCrumb } from 'brainloper-ui';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  private eventSubject = new Subject<any>();
  private eventSubjectBreadCumb = new Subject<any>();

  constructor() { }

  emitEvent(event: any) {
    this.eventSubject.next(event);
  }

  getEvent() {
    return this.eventSubject.asObservable();
  }

  emitEventBreadCumb(event: MenuBreadCrumb) {
    this.eventSubjectBreadCumb.next(event);
  }

  getEventBreadCumb(): Observable<MenuBreadCrumb> {
    return this.eventSubjectBreadCumb.asObservable();
  }
}
